let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aUOgk")).then(() => parcelRequire('hWOEn'));